<button
  [class.mat-stroked-button]="stroke || fliko"
  [class.mat-flat-button]="!stroke"
  [class.inverse]="inverse"
  [class.fliko-stroked-button]="fliko"
  [disabled]="disabled"
>
  <mat-icon [color]="color" [class.inverse]="inverse"> {{ icon }} </mat-icon>
  <ng-content></ng-content>
</button>
